<script>
import Style from "@/views/layouts/style";
import Layout from "../../layouts/main";
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import evaluacionIndicadoresAPI from "../../../services/standards/evaluacionIndicadores/evaluacionIndicadoresAPI";

export default {
  page: {
    title: "6.1.1 Indicadores de Estructura, Proceso y Resultado",
    meta: [{ name: "description", content: appConfig.description }],
  },

  data() {
    return {
      title: "6.1.1 Indicadores de Estructura, Proceso y Resultado",
      items: [
        {
          text: "Estandares",
          href: "/forms/estandares",
        },
        {
          text: "Indicadores de Estructura, Proceso y Resultado",
          active: true,
        },
      ],
      lista: [],
      companyID: this.$store.getters["company/getCompany"].id || null,
    }
  },

  components: {
    Layout,
    Style,
    PageHeader,
  },

  methods: {
    goBack() {
      this.$router.go(-1);
    },

    getList() {
      evaluacionIndicadoresAPI
        .getShowE(this.$route.params.id)
        .then((response) => {
          this.lista = response.data;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },

    async printStructure() {
      try {
        evaluacionIndicadoresAPI.getStructureExcel(this.companyID,this.$route.params.id)
          .then((response) => {
            window.location.href = response
          });
      } catch (error) {
        console.log(error);
      }
    },
  },

  mounted() {
    this.getList();
  }
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row px-3 text-right">
      <div class="col-12 text-right">
        <button @click="printStructure" type="button" class="btn btn-primary m-3" id="tooltip">
          <span class="btn-label"><i class="bx bx-download"></i></span>
          Descargar tabla a excel
        </button>
        <b-tooltip target="tooltip" placement="left">
          Descargar
        </b-tooltip>

        <div class="btn btn-secondary" id="back" @click="goBack">
          <i class="fas fa-arrow-left"></i>
        </div>
        <b-tooltip target="back" placement="left"> Volver </b-tooltip>
      </div>
    </div>
    </br>
    <div class="row">
      <div class="col-md-12">
        <table class="pt-2 table table-bordered table-hover border-bottom divide-y divide-gray-200 rounded">
          <thead>
            <tr>
              <th class="text-center" colspan="7"> INDICADORES DE ESTRUCTURA </th>
            </tr>
            <tr>
              <th></th>
              <th class="text-center align-middle">Items</th>
              <th class="text-center align-middle">Cumple</th>
              <th class="text-center align-middle">No cumple</th>
              <th class="text-center align-middle">No aplica</th>
              <th class="text-center align-middle">Observaciones</th>
            </tr>
          </thead>
          <tbody class="bg-white divide-y divide-gray-200">
            <tr v-for="dato in lista" :key="dato.id">
              <td class="text-center align-middle"> {{ dato.id }} </td>
              <td class="text-center align-middle"> {{ dato.name }} </td>
              <td class="text-center align-middle">
                <input disabled type="checkbox" style="color: #666" :checked="dato.meets === 1"
                  class="mb-2 mr-sm-2 mb-sm-0" />
              </td>
              <td class="text-center align-middle">
                <input disabled type="checkbox" style="color: #666" :checked="dato.fails === 1"
                  class="mb-2 mr-sm-2 mb-sm-0" />
              </td>
              <td class="text-center align-middle">
                <input disabled type="checkbox" style="color: #666" :checked="dato.not_apply === 1"
                  class="mb-2 mr-sm-2 mb-sm-0" />
              </td>
              <td class="text-center align-middle"> {{ dato.observations }} </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </Layout>
</template>